import React from 'react';

import UserStore from 'stores/UserStore';

import { Card, Typography } from 'antd';

const { Paragraph, Title } = Typography;

const CompanyProfile: React.FC = () => {
    return (
        <section data-testid="page-customer-settings-company-profile" data-ready="true">
            <Card title="Company Profile" bordered>
                <Paragraph>Please take a moment to read the company profile information...</Paragraph>
                <div className="flex">
                    <span className="flex font-bold mr-4">Vendor Number:</span>
                    <span>
                        {UserStore.user?.default_contact?.vendor_number !== 'None'
                            ? UserStore.user?.default_contact?.vendor_number
                            : '--'}
                    </span>
                </div>
            </Card>
        </section>
    );
};

export default CompanyProfile;
